import React from 'react'
import styled from 'styled-components'
import { Card } from 'uikit'

export const BodyWrapper = styled(Card)`
  max-width: 440px;
  width: 100%;
  z-index: 1;
  background: rgba(145, 18, 255, 0.05);
  border: 1px solid #9112ff;
  border-radius: 20px;
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper>{children}</BodyWrapper>
}
